const Style = {
    shell: 'flex min-h-0 flex-1 flex-col gap-6',
    identityCard: 'w-full',
    identity: 'flex flex-wrap items-center gap-4',
    name: 'truncate text-lg font-semibold text-text-primary',
    position: 'text-sm text-text-secondary',
    meta: 'inline-flex items-center gap-1.5 text-xs text-text-muted',
    grid: 'grid gap-6 lg:grid-cols-2',
    ticketList: 'max-h-[500px] space-y-2 overflow-auto',
    projectsHeader: 'mb-4 flex flex-wrap items-start justify-between gap-3',
    projectsTitle: 'text-base font-semibold text-text-primary',
    projectsHint: 'mt-0.5 text-sm text-text-secondary',
    projectList: 'space-y-2',
    projectRow:
        'flex items-center justify-between gap-3 rounded-lg border border-border bg-surface px-3 py-2.5',
    projectName: 'truncate text-sm font-medium text-text-primary',
    projectRole: 'text-xs text-text-muted',
};

export default Style;
